import React from 'react';
import BackVideo from '../../components/BackVideo';
import SideLines from '../../components/Svg/side-lines';
import TopLines from '../../components/Svg/top-lines';
import Cart from '../../components/Cart/cart';
import Popup from '../../components/Popup';
// import {CSSTransition, TransitionGroup} from 'react-transition-group';
// import Video from '../../components/Video';

export default ({children, video, intro, title, popup, popupCloseHandler}) => {
    const { classSfx: popupType, opened: popupOpened, data: popupData } = popup;

    return (
        <>
            <section className = { `page-section${popupOpened ? ' in-blur' : ''}` }>
                <div className = 'hud hud-map'>
                    <div className = 'hud__container-decor'>
                        <div className = 'hud__bg'>
                            <div className = 'hud__bg__video'>
                                <div
                                    style={{
                                        opacity: intro.status ? 0 : 1
                                    }}
                                >
                                    <BackVideo video = { video } />
                                </div>

                                { intro.status && (
                                    <BackVideo
                                        video = { intro.video }
                                        onEnded = { intro.onEnded }
                                        loop = { false }
                                    />
                                ) }
                            </div>
                            <div className = 'hud__bg__decor-top'/>
                            <div className = 'hud__bg__decor-bottom'/>
                        </div>

                        <div
                            className = 'hud__header'
                            style = {{height: '70px'}}
                        >
                            <div className = 'hud__header__decor__container'>
                                <div className = 'hud__header__decor__row-1 hud__header__decor__row-center'>
                                    <div className = 'hud__header__decor__item'>
                                        <TopLines />
                                    </div>
                                </div>

                                <div className = 'hud__header__decor__row-2 hud__header__decor__row-space-between'>
                                    <div className = 'hud__header__decor__item'>
                                        <SideLines />
                                    </div>

                                    <div className = 'hud__header__decor__item hud__header__decor__item-reverse'>
                                        <SideLines />
                                    </div>
                                </div>
                            </div>

                            {title && (
                                <div className = 'hud__header__title'>{title}</div>
                            )}
                        </div>

                        <div
                            className = 'hud__footer'
                            style = {{height: '50px'}}
                        >
                            <div className = 'hud__footer__decor__container'>
                                <div className = 'hud__footer__decor__row-1 hud__footer__decor__row-center'>
                                    <div className = 'hud__footer__decor__item'>
                                        <TopLines />
                                    </div>
                                </div>

                                <div className = 'hud__footer__decor__row-2 hud__footer__decor__row-space-between'>
                                    <div className = 'hud__footer__decor__item'>
                                        <SideLines />
                                    </div>

                                    <div className = 'hud__footer__decor__item hud__footer__decor__item-reverse'>
                                        <SideLines />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {children}
                </div>
            </section>

            { popupOpened && (
                <Popup
                    opened
                    closeHandler = { popupCloseHandler }
                    contentClassSfx = { `${popupType}-item` }
                    showCloseButton = { false }
                >
                    <Cart
                        cart = { popupData }
                        closeHandler = { popupCloseHandler }
                    />
                </Popup>
            ) }
        </>
    );
};
